import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const RequestFeedback = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "request-feedback" */ './hocs')),
});
